import React, { Component } from 'react';
import ReactTable from "react-table-6"
import "react-table-6/react-table.css";
import $ from 'jquery';
import { ToastContainer, toast } from "react-toastify";
import { DialogComponent } from '@syncfusion/ej2-react-popups';
import Loader from 'react-loader-spinner';
class Kpi extends Component {
  constructor() {
    super();
    this.dialogClose = () => {
      this.setState({ hideupdateDialog: false, hideAddDialog: false, hideDeletePopup: false, });
    };
    this.settings = { effect: 'Zoom', duration: 400, delay: 0 };

    //for update dialog component ok click
    this.Okbutton = [{
      buttonModel: {
        content: 'OK',
        cssClass: 'e-flat',
        isPrimary: true,
      },
      'click': () => {
        this.fetchKpiDataApi()
        this.dialogClose();
      }
    }];
    this.addedButton = [{
      buttonModel: {
        content: 'OK',
        cssClass: 'e-flat',
        isPrimary: true,
      },
      'click': () => {
        this.fetchKpiDataApi()
        this.dialogClose();
        this.setState({
          disabled: false
        })
      }
    }];

    //for delete dialog component ok click
    this.buttons = [{
      buttonModel: {
        content: 'Yes',
        cssClass: 'e-flat',
        isPrimary: true,

      },
      'click': props => {
        this.deleteKpiAPi(this.state.propsId)
        this.setState({ disabled: false })

      }
    }
      , {
      buttonModel: {
        content: 'No',
        cssClass: 'e-flat',
        isPrimary: true,
      },
      'click': () => {
        this.setState({
          hideDeletePopup: false,
          disabled: false
        });
      }
    }];

    //for delete success
    this.deleteSuccessbuttons = [{
      buttonModel: {
        content: 'Ok',
        cssClass: 'e-flat',
        isPrimary: true,

      },
      'click': props => {
        this.dialogInstance.hide();
        this.fetchKpiDataApi()
        this.setState({ disabled: false })
      }
    }];

    this.state = {
      data: [{
        id: '',
        tagKey: '',
        tagDisplayName: '',
        valueType: '',
        description: '',
        valueType: [],

        deleteRow: false,
      }],
      disabled: false,
      editedId: '-1',
      editImageSrc: './assets/images/edit.svg',
      contentEditable: "false",
      showStore: false,
      hidden: false,
      hideAddDialog: false,
      hideupdateDialog: false,
      hideDeletePopup: false,
      hideDeleteSuccessPopup: false,
      successResp: false,
      pageNum: null,

    }

    this.saveImageSrc = "./assets/images/baseline_save_white_24dp.png";
    this.editImageSrc = "./assets/images/edit2.png";

    this.valueTypeVar = [];
  }

  addRow = (data) => {
    var kpiController = this;
    if (kpiController.state.pageNum != 0) {
      kpiController.setState({ pageNum: 0 })
    }
    this.state.data.unshift({
      id: '',
      tagKey: '',
      tagDisplayName: '',
      valueType: this.valueTypeVar,
      description: '',

    });
    this.setState({
      data: this.state.data,
      disabled: true,

    })
  }
  saveKpiApi(props, e) {

    props.original.tagKey = document.getElementById("tagKey" + props.index).innerText.trim();
    props.original.tagDisplayName = document.getElementById("tagDisplayName" + props.index).innerText.trim();
    props.original.valueType = document.getElementById("valueType" + props.index).value;
    props.original.description = document.getElementById("description" + props.index).innerText.trim();
    this.state.editedId = "-1";
    this.setState(this.state);
    var validateResult = this.validateCells(props.original.tagKey) && this.validateCells(props.original.tagDisplayName) && this.validateCells(props.original.description);

    if (validateResult == true) {
      var addedData = {
        tagKey: props.original.tagKey,
        tagDisplayName: props.original.tagDisplayName,
        valueType: props.original.valueType,
        description: props.original.description,
        projectId: localStorage.getItem("currentProjectId"),
      };
      var addKpiController = this
      $.ajax({
        url: "/api/kpi-tag-info",
        async: false,
        method: 'POST',
        headers: {
          'Authorization': "Bearer " + localStorage.getItem("access_token"),
          'Content-Type': 'application/json',
        },
        data: JSON.stringify(addedData),
        processData: false,
        contentType: "application/json; charset=UTF-8",
        success: function (res) {
          if (res.success === true) {
            addKpiController.notifyAdded();
            addKpiController.fetchKpiDataApi();
            addKpiController.fetchValueTypesApi();
            addKpiController.setState({ disabled: false })
          } else {
            addKpiController.notifyFailedResponse(res.result);
          }
        },
        error: function (xhr) {
          if (xhr.status == 401) {
            window.location.href = "/platform/";
          }
        }

      })
    }
  }
  updateKpiApi(props, e) {

    props.original.tagKey = document.getElementById("tagKey" + props.index).innerText.trim();
    props.original.tagDisplayName = document.getElementById("tagDisplayName" + props.index).innerText.trim();
    props.original.valueType = document.getElementById("valueType" + props.index).value;
    props.original.description = document.getElementById("description" + props.index).innerText.trim();

    var validateResult = this.validateCells(props.original.tagKey) && this.validateCells(props.original.tagDisplayName) && this.validateCells(props.original.description);

    if (validateResult == true) {
      var addedData = {
        tagKey: props.original.tagKey,
        tagDisplayName: props.original.tagDisplayName,
        valueType: props.original.valueType,
        description: props.original.description,

      };
      var updatedData = {
        tagKey: props.original.tagKey,
        tagDisplayName: props.original.tagDisplayName,
        valueType: props.original.valueType,
        description: props.original.description,
        id: props.original.id,
        projectId: localStorage.getItem("currentProjectId"),

      };
      var updatedDataController = this
      $.ajax({
        url: "/api/kpi-tag-info",
        async: false,
        method: 'PATCH',
        headers: {
          'Authorization': "Bearer " + localStorage.getItem("access_token"),
          'Content-Type': 'application/json',

        },
        data: JSON.stringify(updatedData),
        processData: false,
        contentType: "application/json; charset=UTF-8",
        success: function (res) {
          if (res.success === true) {
            updatedDataController.state.editedId = "-1";
            updatedDataController.notifyUpdate();
            updatedDataController.fetchKpiDataApi();
            updatedDataController.fetchValueTypesApi();
          } else {
            updatedDataController.notifyFailedResponse("Same tag available for the project,please change the Tag.");
          }
        },
        error: function (xhr) {
          if (xhr.status == 401) {
            window.location.href = "/platform/";
          }
        }


      })
    }
  }

  makeCelledit(props, e) {
    this.markAsBeingEdited(this.state.data[props.index].id);
  }

  markAsBeingEdited(id) {
    this.state.editedId = id;
    var stateObj = this.state;
    this.setState(stateObj);
  }

  deleteKpiAPi = (id) => {
    let deleteRowViewController = this.state.data;
    let deleteApiViewController = this;
    var deleteConstructorVariables = this;

    if (id == "") {
      deleteApiViewController.setState({ deleteRow: true });
      deleteConstructorVariables.setState({ hideDeletePopup: false });
      deleteConstructorVariables.setState({ hideDeleteSuccessPopup: true });
      deleteRowViewController.splice(id, 1);
    } else {
      $.ajax({
        url: "/api/kpi-tag-info/" + id,
        async: false,
        method: 'DELETE',
        headers: { "Authorization": "Bearer " + localStorage.getItem("access_token") },
        success: function (res) {

          if (res.success === true) {

            deleteApiViewController.setState({ deleteRow: true });
            deleteConstructorVariables.setState({ hideDeletePopup: false });
            deleteConstructorVariables.notifyDelete();
            deleteRowViewController.splice(id, 1);
          } else {
            deleteRowViewController.notifyError();
          }
        },
        error: function (xhr) {
          if (xhr.status == 401) {
            window.location.href = "/platform/";
          }
        }
      });
    }

    if (this.state.deleteRow) {
      this.state.data.splice(id, 1);
    }
    deleteConstructorVariables.fetchKpiDataApi();
    deleteConstructorVariables.fetchValueTypesApi();

  }
  componentDidMount() {
    setTimeout(() => {
      this.fetchValueTypesApi();
      this.fetchKpiDataApi();
    }, 300);
    var thisController = this;
    document.addEventListener("projectChanged", function (event) {
      thisController.projectId = event.projectId;
      thisController.fetchValueTypesApi(event.projectId);

      thisController.fetchKpiDataApi(event.projectId);
    });

  }

  validateCells(tagKey) {
    if ((tagKey == "")) {
      this.notifyEmptyTagKeyFields();
      return false;
    }
    else {
      return true;
    }

  }
  validateCells(tagDisplayName) {
    if ((tagDisplayName == "")) {
      this.notifyEmptyFields();
      return false;
    }
    else {
      return true;
    }

  }

  validateCells(description) {
    if ((description == "")) {
      this.notifyEmptyFields();
      return false;
    }
    else {
      return true;
    }

  }

  refreshData = (id) => {
    var refreshContent = this
    refreshContent = this.state.editedId = id;
    this.fetchKpiDataApi()
    this.setState({ disabled: false })
  }

  fetchValueTypesApi = (projectId) => {
    if (!projectId) {
      projectId = this.projectId;
      if (!projectId) {
        projectId = localStorage.getItem('currentProjectId');
      }
    }
    var valueTypeController = this;
    $.ajax(
      {
        url: "/api/kpi-tag-info-value-types",
        async: false,
        method: 'GET',
        data: { projectId: projectId },
        headers: { 'Authorization': "Bearer " + localStorage.getItem("access_token") },
        success: function (res) {
          if (res.success === true) {
            var valueTypes = res.result;
            valueTypeController.state.data.valueType = valueTypes
            var numberOfvalueTypes = valueTypes.length;
            var ele3 = document.getElementById("valueType");
            valueTypeController.valueTypeVar = [];
            for (var i = 0; i < numberOfvalueTypes; i++) {
              valueTypeController.valueTypeVar[i] = valueTypes[i]['key']
            }
            successResp: true
          }
        },
        error: function (xhr) {
          if (xhr.status == 401) {
            window.location.href = "/platform/";
          }
        }
      }
    )
  }

  fetchKpiDataApi = (projectId) => {
    if (!projectId) {
      projectId = this.projectId;
      if (!projectId) {
        projectId = localStorage.getItem('currentProjectId');
      }
    }
    var KpiController = this;

    $.ajax({
      url: "/api/kpi-tag-info",
      async: false,
      method: 'GET',
      data: { projectId: projectId },
      headers: {
        "Authorization": "Bearer " + localStorage.getItem("access_token"),
        "Content-Type": "application/json",
      },
      success: function (res) {
        if (res.success === true) {
          var tagKeys = res.result;
          KpiController.setState({
            data: tagKeys,
            successResp: true
          })
        } else {

          KpiController.notifyFailedResponse(res.result);
        }
      },
      error: function (xhr) {
        if (xhr.status == 401) {
          window.location.href = "/platform/";
        }
      }

    });
  }

  handleChange = (e) => {
    this.setState({ selectValue: e.target.value });
  }

  notifyAdded() {
    toast.dismiss();
    toast(<b><img src="assets/images/done.svg" style={{ paddingRight: '0px' }} content="" />&nbsp;&nbsp;Added Successfully</b>, {
      position: "top-center",
    });
  }

  notifyError() {
    toast.dismiss();
    toast(<b><img src="assets/images/warn.svg" style={{ paddingRight: '0px', height: '20px', width: '20px' }}
      content="" />&nbsp;&nbsp;Oops! Error occurred.Please try again</b>, {
      position: "top-center"
    });
  }

  notifyUpdate() {
    toast.dismiss();
    toast(<b><img src="assets/images/done.svg" style={{ paddingRight: '0px' }} content="" />&nbsp;&nbsp;Updated Successfully</b>, {
      position: "top-center",
    });
  }

  notifyDelete() {
    toast.dismiss();
    toast(<b><img src="assets/images/done.svg" style={{ paddingRight: '0px' }} content="" />&nbsp;&nbsp;Deleted Successfully</b>, {
      position: "top-center",
    });
  }
  notifyEmptyFields() {
    toast(<b>Please fill all fields</b>, {
      position: "bottom-center",
      color: "#007aff"
    });
  }

  notifyEmptyTagKeyFields() {
    toast(<b >Please change the tag field</b>, {
      position: "bottom-center",
      color: "#007aff"
    });
  }

  notifyEmptyFieldForAdd() {
    toast.dismiss();
    toast(<b> Please fill all the data</b>, {
      position: "top-center"
    });
  }


  notifyFailedResponse(response) {
    toast.dismiss();
    toast(<b style={{ color: "red" }}>{response}</b>, {
      position: "top-center",
      color: "red"

    });
  }



  onPageChange = (e) => {
    this.setState({ pageNum: e })
  }

  render() {
    const { data } = this.state
    const columns = [

      {
        Header: 'Id',
        accessor: 'id',
        show: false,
        Cell: props => (
          <div name="id" id={"id" + props.index}>{props.original.id}
          </div>)
      },

      {
        Header: () => <b>Tag</b>,
        accessor: 'tagKey',
        Cell: props => (
          <div name="tagKey">
            <div className="input"
              style={{ width: '98%', padding: '8px', 
              border: (props.original.id == "" || props.original.id == this.state.editedId) ? '1px solid #D2D4DC' : 'none', borderRadius: (props.original.id == null) ? '2px' : 'none', paddingLeft: '2px' }}
              id={"tagKey" + props.index}
              rows="1"
              maxlength="250"
              contentEditable={!((props.original.id == "") ? false :
                props.original.id != this.state.editedId) ? "plaintext-only" : false}
              >{props.original.tagKey}
            </div>
          </div>)
      },
      {
        Header: () => <b>Tag Display Name</b>,
        accessor: 'tagDisplayName',
        Cell: props => (
          <div name="tagDisplayName">
            <div className="input"
                    style={{ width: '98%', padding: '8px', 
                    border: (props.original.id == "" || props.original.id == this.state.editedId) ? '1px solid #D2D4DC' : 'none', borderRadius: (props.original.id == null) ? '2px' : 'none', paddingLeft: '2px' }}              id={"tagDisplayName" + props.index}
              rows="1"
              maxlength="250"
              contentEditable={!((props.original.id == "") ? false :
                props.original.id != this.state.editedId) ? "plaintext-only" : false}
              >{props.original.tagDisplayName}
            </div>
          </div>)
      },
      {
        Header: () => <b>Tag Description</b>,
        accessor: 'description',
        Cell: props => (
          <div name="description">
            <div className="input"
                    style={{ width: '98%', padding: '8px', 
                    border: (props.original.id == "" || props.original.id == this.state.editedId) ? '1px solid #D2D4DC' : 'none', borderRadius: (props.original.id == null) ? '2px' : 'none', paddingLeft: '2px' }}              id={"description" + props.index}
              rows="1"
              maxlength="250"
              contentEditable={!((props.original.id == "") ? false :
                props.original.id != this.state.editedId) ? "plaintext-only" : false}
              >{props.original.description}
            </div>
          </div>)
      },

      {
        Header: <b>Tag Value Type</b>,
        textAlign: 'screenLeft',
        accessor: 'valueType',
        Cell: props => {
          return (
            <div className="container-fluid" style={{ textAlign: "right" }}>
              <select className="input-group form-control select2 "
                tabIndex={-1} aria-hidden="true"
                name="valueType"
                style={{ background: 'white', border: 'none' }}
                id={"valueType" + props.index}
                disabled={(props.original.id != "") ? props.original.id != this.state.editedId : false} >{props.original.tagKey}{this.valueTypeVar.map((valueType) => <option key={valueType}
                  selected={props.original.valueType == valueType}>{valueType}</option>)}
              </select>
            </div>
          )
        },
      },

      {
        Header: <b>Action</b>,
        accessor: 'action',
        width: 200,
        Cell: props => (
          <div id="action">
            <button style={{ backgroundColor: "#ffffff", border: "none", marginTop: '-9px', marginLeft: '-6px' }} >
              <img className="img-responsive"
                title={(props.original.id == "") ||
                  (this.state.data[props.index].id == this.state.editedId) ? 'Save' : 'Edit'}
                style={{ marginTop: '6px', backgroundColor: '#282a65', borderRadius: '5px', padding: '1px' }}
                src={(props.original.id == "") ? this.saveImageSrc : ((props.original.id != this.state.editedId) ? this.editImageSrc : this.saveImageSrc)}
                onClick={(e) => {
                  (props.original.id == "") ? this.saveKpiApi(props, e) : (props.original.id == this.state.editedId) ?
                    this.updateKpiApi(props, e) : this.makeCelledit(props, e);
                }} />
            </button>


            <button style={{
              backgroundColor: "#ffffff", border: "none", marginTop: '-9px', marginLeft: '-6px'
            }} title="Delete">
              <img className="img-responsive" src={"./assets/images/baseline_delete_white_24dp.png"}
                style={{
                  marginTop: '6px', backgroundColor: '#282a65', borderRadius: '5px', padding: '1px'
                }}
                onClick={() => (props.original.id) === '' ?
                  this.fetchKpiDataApi() :
                  this.setState({
                    hideDeletePopup: true, deletePropIndex: props.index,
                    propsId: props.original.id
                  })}
              /></button>
          </div>), width: 100
      },

    ]
    return (
      <div style={{ marginRight: '1%' }}><Loader
        type="TailSpin" color="#282a65" visible={(this.state.successResp) ? false : true} height={300} width={50}
        style={{ textAlign: 'center' }} />
        <div className="container-fluid" style={{ background: "#F9F9FB", display: this.state.successResp ? 'block' : 'none' }}>
          {/* for toaster */}
          <link rel="stylesheet" href="assets/css/ReactToastify.css" />
          {/* for reactTable */}
          <link rel="stylesheet" href="assets/css/React_Table_CSS/react-table.css" />
          {/*for dialog component */}
          <link href="assets/css/ej2-base.css" rel="stylesheet" />
          <link href="assets/css/ej2-react-buttons.css" rel="stylesheet" />
          <link href="assets/css/ej2-react-popups.css" rel="stylesheet" />
          <link href="assets/css/ej2-inputs.css" rel="stylesheet" />
          <link href="assets/css/screenResolution.css" rel="stylesheet" />
          <link rel="shortcut icon" type="image/png" href="assets/images/bot.ico" />
          <title> Dheeyantra | BackEnd Api </title>
          {/* Font Awesome Icons */}
          <link rel="stylesheet" href="plugins/font-awesome/css/font-awesome.min.css" />
          {/* IonIcons */}
          <link rel="stylesheet" href="//code.ionicframework.com/ionicons/2.0.1/css/ionicons.min.css" />
          <link rel="stylesheet" href="assets/fonts/flat-icon/flaticon.css" />
          {/* Theme style */}
          <link rel="stylesheet" href="assets/css/adminlte.css" />
          <link href="https://cdn.jsdelivr.net/npm/gijgo@1.9.6/css/gijgo.min.css" rel="stylesheet" />
          <link rel="stylesheet" href="plugins/select2/select2.min.css" />
          <link rel="stylesheet" href="assets/css/custom-style.css" />
          <link rel="stylesheet" href="assets/css/styles.css" />
          <div className="row" style={{ marginLeft: '10px' }}>
            <div className="col-sm-5">
              <h6 className="nav-item" style={{ color: '#282a65', marginTop: '60px' }}>Define Key Performance Indices</h6>
            </div>
            {/* Add button */}
            <div className="col-sm-7 p-0" style={{ marginTop: '11px' }}>
              <div className="d-flex flex-row-reverse pt-2">
                <div className="p-2">
                  <button className="btn action-button"
                    id="addMsg" title=" Add "
                    onClick={this.state.disabled ? this.notifyEmptyFieldForAdd : this.addRow}>
                    <img src="assets/images/add_white_24dp.png" />
                  </button>

                  <button title="Refresh" onClick={this.refreshData} type="button" className="btn action-button">
                    <img src="./assets/images/refresh_white_24dp.png"></img></button>

                </div>
              </div>
            </div>
          </div>

          <div className="row" style={{ marginLeft: '11px' }}>
            <div className="col-lg-12 ">
              <div className="card">
                <ReactTable
                  data={data}
                  columns={columns}
                  defaultPageSize={10}
                  pageSizeOptions={[5, 10, 15]}
                  onPageChange={this.onPageChange}
                  page={this.state.pageNum}

                />
              </div>
              <ToastContainer className="Toast-at-center" />
              {/*Dialog Component For Deletion Confirmation*/}
              <DialogComponent width='400px' animationSettings={this.settings}
                header='KPI' showCloseIcon={true} buttons={this.buttons}
                ref={dialog => this.dialogInstance = dialog}
                visible={this.state.hideDeletePopup} close={this.dialogClose}>
                <img src="./assets/images/warn.svg" style={{ paddingRight: '0px', height: '20px', width: '20px' }}
                  content="" />&nbsp;Do you want to delete KPI?<br />Note: Press 'Yes' to delete or press 'No' to decline.
              </DialogComponent>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default Kpi;



// WEBPACK FOOTER //
// ./src/projectmgmt/reports/Kpi.js